<template>
  <section>
    <Paragraph class="font-jost-regular text-blue-dark text-[25px] leading-[30px] mt-[60px]" text="Verification" />
    <div class="t-results text-lg mt-5">
      <section class="t-results-body grid grid-cols-2 gap-[90px] bg-white">
        <div>          
          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Block Number
            </div>
            <router-link v-if="transactionData"
              class="col block px-2.5 flex relative text-blue-light cursor-pointer text-ellipsis text-[16px]"
              :to="{ name: 'block', params: { chainNumber: transactionData.chainNumber || $route.params.chainNumber || $route.params.chain, blockNumber: transactionData.block } }">
              #{{ transactionData.block }}
            </router-link>
          </div>

          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Chain Number
            </div>
            <router-link
              v-if="transactionData.chainNumber !== undefined && transactionData.chainNumber !== null"
              class="col text-blue-light cursor-pointer text-[16px]"
              :to="{ name: 'chain', params: { chainNumber: transactionData.chainNumber } }"
            >
              #{{ transactionData.chainNumber }}
            </router-link>
            <div v-else class="col text-[16px]">
              {{ transactionData.chainNumber }}
            </div>
          </div>

          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Coin amount
            </div>
            <div class="col flex px-2.5 gap-[10px]">
              <p class="block relative text-ellipsis text-blue-dark text-[16px]">
                {{ getBalance(coinValue.value) }} <span class="uppercase">GEEQ</span>
              </p>
            </div>
          </div>

          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Transaction Fee
            </div>
            <div class="col font-jost-regular px-2.5 text-blue-dark text-[16px]">
              {{ getBalance(transactionData.fee) }} <span class="uppercase">GEEQ</span>
            </div>
          </div>

          <div class="row text-left items-center text-blue-dark px-2.5 py-3.5 border-b border-[#2699FB] result-row flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Attestation Hash
            </div>
            <div class="col flex items-center font-jost-regular px-2.5 text-blue-dark">
              <p class="block text-ellipsis text-[16px]">
                <span class="text-blue-dark text-[16px]">
                  {{ attestHash }}
                </span>
              </p>

              <CopyIcon :isActive="checkIfIsEqual(attestHash, 'attestHash')" @click="copy(attestHash, 'attestHash')" title="Copy hash"
                class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top" />
            </div>
          </div>

          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              From (Issuer)
            </div>
            <div class="col flex px-2.5 gap-[10px]">
              <router-link v-if="sender" :to="{path: getLinkToAccount(sender)}"
                class="block text-ellipsis text-[16px]">
                <span class="text-blue-light text-[16px]">
                  {{ sender }}
                </span>
              </router-link>
              <CopyIcon :isActive="checkIfIsEqual(sender, 'sender')" @click="copy(sender, 'sender')" title="Copy hash"
                class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top" />
            </div>
          </div>

          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              To (Owner)
            </div>
            <div class="col flex px-2.5 gap-[10px]">
              <router-link v-if="receiver" :to="{path: getLinkToAccount(receiver)}"
                class="block text-ellipsis text-[16px]">
                <span class="text-blue-light text-[16px]">
                  {{ receiver }}
                </span>
              </router-link>
              <CopyIcon :isActive="checkIfIsEqual(receiver, 'receiver')" @click="copy(receiver, 'receiver')"
                title="Copy hash" class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top" />
            </div>
          </div>

          <!-- <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              NFT ID
            </div>
            <div class="col flex px-2.5 gap-[10px]">
              <router-link v-if="nftId" class="block relative text-ellipsis text-[#5B6BD5] cursor-pointer"
                :to="{ name: 'nft', params: { nftId: nftId } }">
                {{ nftId }}
              </router-link>
              <CopyIcon :isActive="checkIfIsEqual(nftId)" @click="copy(nftId)" title="Copy hash"
                class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top" />
            </div>
          </div> -->

          <div v-if="metadata && metadata.length"
            class="first__col__last__row row text-left items-center text-blue-dark px-2.5 py-3.5 result-row flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Digital Asset Metadata
            </div>
            <div class="col flex-col px-2.5 text-blue-dark gap-[10px]">
              <p class="block font-jost-regular text-ellipsis break-all text-[16px]" v-for="(i, ind) in metadata" :key="ind">
                {{ i }}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Digital Asset ID
            </div>
            <div class="col flex px-2.5 gap-[10px]">
              <div v-if="transactionData"
                class="block text-ellipsis text-[16px]">
                <span class="text-[16px]">
                  {{ transactionData.acctNumApp }}
                </span>
              </div>
              <CopyIcon :isActive="checkIfIsEqual(transactionData.acctNumApp, 'acctNumApp')" @click="copy(transactionData.acctNumApp, 'acctNumApp')"
                title="Copy digital asset ID" class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top" />
            </div>
          </div>

          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Refhash
            </div>
            <div class="col flex px-2.5 gap-[10px]">
              <div v-if="transactionData"
                class="block text-ellipsis text-[16px]">
                <span class="text-[16px]">
                  {{ transactionData.refHash }}
                </span>
              </div>
              <CopyIcon :isActive="checkIfIsEqual(transactionData.refHash, 'refHash')" @click="copy(transactionData.refHash, 'refHash')"
                title="Copy hash" class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top" />
            </div>
          </div>
          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Status
            </div>
            <div class="flex items-center gap-3 col font-jost-regular px-2.5 text-[16px]">
              <span class="px-2 py-1 text-base font-medium rounded uppercase" 
                  :class="transactionData.status === 'valid' ? 'bg-green-100 text-green-800' : 
                    transactionData.status === 'invalid' ? 'bg-red-100 text-red-800' : 
                    'bg-yellow-100 text-yellow-800'">
                {{ transactionData.status || 'PENDING' }}
              </span>
            </div>
          </div>
         
          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Signature
            </div>
            <div class="col flex items-center font-jost-regular px-2.5 text-[16px]">
              <p v-if="transactionData" class="block text-ellipsis text-[16px]">
                <span class="text-blue-dark text-[16px]">
                  {{ transactionData.signature }}
                </span>
              </p>
              <CopyIcon :isActive="checkIfIsEqual(transactionData.signature, 'signature')" @click="copy(transactionData.signature, 'signature')"
                title="Copy hash" class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top" />
            </div>
          </div>
          <div
            class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row border-b border-[#2699FB] flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              Timestamp
            </div>
            <div class="col font-jost-regular px-2.5 text-blue-dark text-[16px]">
              {{ getTxCreationDate() }}
            </div>
          </div>
          <!-- <div class="row text-left items-center text-blue-dark px-2.5 py-3.5 result-row flex items-baseline">
            <div class="col font-jost-regular text-blue-dark block text-[16px] leading-[21px] flex relative">
              NFT Hash
            </div>
            <div class="col flex items-center font-jost-regular px-2.5 text-blue-dark">
              <p v-if="nftHash" class="block text-ellipsis text-[16px]">
                {{ nftHash }}
              </p>
              <CopyIcon :isActive="checkIfIsEqual(nftHash, 'nftHash')" @click="copy(nftHash, 'nftHash')"
                title="Copy hash" class="min-w-[16px] h-[19px] inline-block cursor-pointer align-top" />
            </div>
          </div> -->
        </div>
      </section>
    </div>
  </section>

</template>

<script>
import moment from 'moment';
import string from '@/helpers/string';

import CopyIcon from "@/components/svg/CopyIcon.vue";
import Paragraph from "@/components/web/ParagraphComponent";
import { getLinkToAccount } from '@/helpers/common';

export default {
  name: 'MintNftOverview',
  components: {
    CopyIcon,
    Paragraph
  },
  props: {
    transactionData: {
      type: Object,
      required: true
    },
    transactionRefHash: {
      type: String,
      required: true
    },
    signedBy: {
      type: String,
      required: true
    },
  },
  computed: {
    values() {
      const values = this.transactionData.values;
      if (Array.isArray(values)) {
        return values;
      }

      if (this.transactionData.value && typeof this.transactionData.value === 'object') {
        return [this.transactionData.value];
      }

      return [];
    },
    coinValue() {
      const coinValue = this.values.find((item) => item && item.type === 'coin');
      return coinValue || { value: '', type: 'coin' };
    },
    attestHash() {
      return this.transactionData?.payload?.attestationHash || '';
    },
    // signedByPublicKey() {
    //   return this.transactionData.uat.uatData.signedBy;
    // },
    metadata() {
      return this.transactionData.payload?.metadata;
    },
    // stackPosition() {
    //   return this.transactionData.uat.overview.stackPosition;
    // },
    sender() {
      const sender = this.transactionData.from;
      return sender || '';
    },
    receiver() {
      const receiver = this.transactionData.to;
      return receiver || '';
    },
    // nftId() {
    //   const nftId = this.transactionData.uat.overview.nftId;
    //   return nftId || '';
    // },
    // nftHash() {
    //   const nftHash = this.transactionData.uat.overview.nftHash;
    //   return nftHash || '';
    // },
    metadataString() {
      if (!this.modifiedTxPayload) return '';
      const metaList = this.modifiedTxPayload.metadataList;

      return metaList.join(', ');
    },
    modifiedTxPayload() {
      let payload = this.transactionData ? { ...this.transactionData.payload } : {};

      return payload.metadataList ? payload.metadataList : [];
    },
  },
  data() {
    return {
      copied: '',
      balanceDivisor: parseInt(process.env.VUE_APP_BALANCE_DIVISOR) || 1000000000,
    };
  },
  methods: {
    getLinkToAccount(walletAddress) {
      return getLinkToAccount(walletAddress, this.transactionData.chainNumber);
    },
    copy(hash, uId = 0) {
      string.copyToClipboard(hash);
      this.setCopied(hash + uId);
    },
    setCopied(hash) {
      this.copied = hash;
    },
    checkIfIsEqual(str, uId = 0) {
      return string.isTextEqualTo(str, this.copied, uId);
    },
    getBalance(amount) {
      if (amount === null || amount === undefined || amount === '') {
        return amount;
      }

      const parsedAmount = Number(amount);
      if (Number.isNaN(parsedAmount) || !this.balanceDivisor) {
        return amount;
      }

      return parsedAmount / this.balanceDivisor;
    },
    getTxCreationDate() {
      const createdAt = this.transactionData.createdAt;
      if (!createdAt) {
        return '';
      }
      return moment(createdAt).format('YYYY-MM-DD HH:mm:ss');
    },
    getNftTitle(metadata) {
      const title = this.findItemStartingWith(metadata, 't:');
      return title ? title : '';
    },
    getCreatorName(metadata) {
      const artistName = this.findItemStartingWith(metadata, 'u:');
      return artistName ? artistName : '';
    },
    getNftFileUrl(metadata) {
      const fileUrl = this.findItemStartingWith(metadata, 'i:');
      return fileUrl ? fileUrl : '';
    },
    findItemStartingWith(arr, keyName) {
      if (!arr || !arr.length) return null;

      for (const item of arr) {
        if (item.startsWith(keyName)) {
          return item.substring(2);
        }
      }
      return null;
    },
  }
}
</script>

<style>
.transaction-explorer .vjs-value {
  color: #2699FB !important;
  font-size: 18px;
  line-height: 26px;
  font-family: 'Jost-Regular', monospace !important;
}

.transaction-explorer .vjs-tree {
  font-size: 18px;
  line-height: 26px;
  overflow-x: auto !important;
  white-space: nowrap;
  color: #2699FB !important;
}

.transaction-explorer .vjs-key {
  font-family: 'Jost-Regular', monospace !important;
  color: #2699FB !important;
}
</style>
<style scoped>
.col {
  flex: 1;
  /* distributes space on the line equally among items */
  width: calc(100% / 2);
}

.t-results-body {
  padding: 28px 21px;
  border-radius: 8px;
}

.t-results-body .row:first-child {
  border-top: unset;
}

@media (max-width: 992px) {
  .t-results-body {
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  .first__col__last__row {
    border-bottom: 1px solid #2699FB;
  }
}
</style>
